export function announceStatus(text) {
    const element = document.createElement('div');
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('role', 'status');
    element.className = 'sr-only';
    document.body.appendChild(element);
    setTimeout(() => (element.textContent = text), 1000);
    setTimeout(() => document.body.removeChild(element), 10000);
}
